class DateTimes {
  static get today() { return new Date(); }

  static get yesterday() {
    const dt = new Date();
    dt.setDate(dt.getDate() - 1);
    return dt;
  }
}

export default DateTimes;
